export default {
    "de": {
        "A fresh verification link has been sent to your email address.": "Ein neuer Verifikationslink wurde verschickt.",
        "All rights reserved.": "Alle Rechte vorbehalten.",
        "Before proceeding, please check your email for a verification link.": "Bestätigen Sie bitte zuerst Ihre E-Mail.",
        "click here to request another": "klicken Sie hier, um eine neue anzufordern.",
        "Confirm Password": "Passwort bestätigen",
        "E-Mail Address": "E-Mail Adresse",
        "Error": "Fehler",
        "Forbidden": "Unzulässig",
        "Forgot Your Password?": "Passwort vergessen?",
        "Go Home": "Nach Hause",
        "Hello!": "Hallo!",
        "hi": "hallo",
        "If you did not create an account, no further action is required.": "Wenn Sie keinen Account beantragt haben ist keine weitere Handlung nötig.",
        "If you did not receive the email": "Wenn Sie keine E-Mail erhalten haben",
        "If you did not request a password reset, no further action is required.": "Wenn Sie keine Zurücksetzung des Passworts beantragt haben ist keine weitere Handlung nötig.",
        "If you’re having trouble clicking the \"{actionText}\" button, copy and paste the URL below\ninto your web browser: [{actionURL}]({actionURL})": "Wenn Sie Schwierigkeiten haben, den \"{actionText}\" Button zu drücken, fügen sie bitte folgende Adresse in Ihren Browser ein: [{actionURL}]({actionURL})",
        "Login": "Anmelden",
        "Logout": "Abmelden",
        "Name": "Name",
        "Oh no": "Oh nein",
        "Page Expired": "Seite abgelaufen",
        "Page Not Found": "Seite konnte nicht gefunden werden",
        "Password": "Passwort",
        "Please click the button below to verify your email address.": "Bitte klicken Sie den Button, um Ihre E-Mail Adresse zu bestätigen.",
        "Regards": "Mit freundlichen Grüßen",
        "Register": "Registrieren",
        "Remember Me": "Angemeldet bleiben",
        "Reset Password": "Passwort zurücksetzen",
        "Reset Password Notification": "Passwort zurücksetzen Benachrichtung",
        "Send Password Reset Link": "Link zum Zurücksetzen des Passworts senden",
        "Service Unavailable": "Service nicht verfügbar",
        "Sorry, the page you are looking for could not be found.": "Tut uns leid, die Seite konnte nicht gefunden werden.",
        "Sorry, you are forbidden from accessing this page.": "Tut uns leid, Sie haben keine Rechte, diese Seite zu besuchen.",
        "Sorry, you are making too many requests to our servers.": "Tut uns leid, Sie machen derzeit zu viele Anfragen an unseren Server.",
        "Sorry, you are not authorized to access this page.": "Tut uns leid, Sie haben keine Rechte, diese Seite zu besuchen.",
        "Sorry, your session has expired. Please refresh and try again.": "Tut uns leid, Ihre Sitzung ist abgelaufen. Bitte laden Sie die Seite neu und probieren Sie es erneut.",
        "Sorry, we are doing some maintenance. Please check back soon.": "Tut uns leid, wir arbeiten gerade an unserer Webseite. Bitte versuchen Sie es später erneut.",
        "This password reset link will expire in {count} minutes.": "Dieser Link zum Zurücksetzen des Passworts läuft in {count} Minuten ab.",
        "Toggle navigation": "Navigation umschalten",
        "Too Many Requests": "Zu viele Anfragen",
        "Unauthorized": "Nicht autorisiert",
        "Verify Email Address": "E-Mail Adresse bestätigen",
        "Verify Your Email Address": "Bestätigen Sie Ihre E-Mail Adresse",
        "You are receiving this email because we received a password reset request for your account.": "Sie erhalten diese E-Mail, weil wir einen Antrag auf eine Zurücksetzung Ihres Passworts bekommen haben.",
        "Whoops!": "Ups!",
        "Whoops, something went wrong on our servers.": "Ups, etwas ist schief gelaufen.",
        "Articles": "Artikel",
        "Search": "Suche",
        "Title": "Titel",
        "home": "zuhause",
        "about": "über",
        "Action": "Aktion",
        "Modifed with success!": "Mit Erfolg verändert!",
        "Added with success!": "Mit Erfolg hinzugefügt!",
        "admin": {
            "title": "Titel",
            "search": "Suchen"
        },
        "auth": {
            "failed": "Diese Kombination aus Zugangsdaten wurde nicht in unserer Datenbank gefunden.",
            "throttle": "Zu viele Loginversuche. Versuchen Sie es bitte in {seconds} Sekunden nochmal."
        },
        "front": {
            "register": "Registrieren",
            "articles": "Artikel",
            "search": "Suchen",
            "title": "Titel",
            "home": "Zuhause",
            "about": "über",
            "action": "Aktion",
            "contact": "Kontakt",
            "close": "Schließen",
            "cancel": "Abbrechen",
            "from": "von",
            "category": "Kategorie",
            "send_message": "Sende eine Nachricht",
            "subject": "Betreff",
            "submit": "Submit",
            "confirm_delete_article": "Möchten Sie diesen Artikel wirklich löschen? Diese Aktion ist irreversibel!",
            "confirm": "Bestätigen",
            "text": "Text",
            "list": "Liste",
            "account": "Konto",
            "my_objects": "meine Objekte",
            "loading": "Wird geladen",
            "balance": "Balance",
            "create": "Erstellen",
            "serial_number": "Ordnungsnummer",
            "type": "Art",
            "original_country": "Original-Land",
            "ch_number": "CH-Nummer",
            "producer": "Hersteller",
            "model": "Modell",
            "caliber": "Kaliber",
            "smaller_than_60cm": "Kleiner als 60 cm",
            "large_capacity_store": "Großraumspeicher",
            "serial_number_info": "Bitte verwenden Sie nur Zeichen ohne Akzente. Verbotene Leerzeichen. Autorisierte Trennzeichen: . Punkt  - Bindestrich  _underscore",
            "yes": "ya",
            "no": "nein",
            "objects": "Objekte",
            "transfer": "transfer",
            "authorizations": "Autorisierungen",
            "ownership": "Eigentum",
            "approved": "Genehmigt",
            "approval": "Genehmigung",
            "recipient": "Empfänger",
            "doctype": "Art des Ausweises",
            "docnumber": "Nummer des Ausweises",
            "family_name": "Nachname",
            "maiden_name": "Mädchenname",
            "first_name": "Vorname",
            "birthday": "Geburtstag",
            "state": "Staat",
            "npa": "Postleitzahl",
            "place": "Platz",
            "information": "information",
            "create_conflict": "Erstellungskonflikt. Bitte überprüfen Sie die unten stehenden Warnmeldungen",
            "conflict_message": "Ein Objekt des gleichen Typs und der gleichen Seriennummer ist bereits einer anderen Halteadresse zugeordnet",
            "handle_conflict": "mit diesem Konflikt umgehen",
            "copy": "Kopieren",
            "logs": "logs",
            "categories": "Kategorien",
            "add": "hinzufügen",
            "translations": "übersetzungen",
            "address": "Adresse"
        },
        "pagination": {
            "previous": "&laquo; Zurück",
            "next": "Weiter &raquo;"
        },
        "passwords": {
            "password": "Passwörter müssen mindestens 6 Zeichen lang sein und korrekt bestätigt werden.",
            "reset": "Das Passwort wurde zurückgesetzt!",
            "sent": "Passworterinnerung wurde gesendet!",
            "token": "Der Passwort-Wiederherstellungs-Schlüssel ist ungültig oder abgelaufen.",
            "user": "Es konnte leider kein Nutzer mit dieser E-Mail-Adresse gefunden werden."
        },
        "routes": {
            "home": "zuhause"
        },
        "validation": {
            "accepted": "{attribute} muss akzeptiert werden.",
            "active_url": "{attribute} ist keine gültige Internet-Adresse.",
            "after": "{attribute} muss ein Datum nach dem {date} sein.",
            "after_or_equal": "{attribute} muss ein Datum nach dem {date} oder gleich dem {date} sein.",
            "alpha": "{attribute} darf nur aus Buchstaben bestehen.",
            "alpha_dash": "{attribute} darf nur aus Buchstaben, Zahlen, Binde- und Unterstrichen bestehen.",
            "alpha_num": "{attribute} darf nur aus Buchstaben und Zahlen bestehen.",
            "array": "{attribute} muss ein Array sein.",
            "before": "{attribute} muss ein Datum vor dem {date} sein.",
            "before_or_equal": "{attribute} muss ein Datum vor dem {date} oder gleich dem {date} sein.",
            "between": {
                "numeric": "{attribute} muss zwischen {min} & {max} liegen.",
                "file": "{attribute} muss zwischen {min} & {max} Kilobytes groß sein.",
                "string": "{attribute} muss zwischen {min} & {max} Zeichen lang sein.",
                "array": "{attribute} muss zwischen {min} & {max} Elemente haben."
            },
            "boolean": "{attribute} muss entweder 'true' oder 'false' sein.",
            "confirmed": "{attribute} stimmt nicht mit der Bestätigung überein.",
            "date": "{attribute} muss ein gültiges Datum sein.",
            "date_equals": "The {attribute} must be a date equal to {date}.",
            "date_format": "{attribute} entspricht nicht dem gültigen Format für {format}.",
            "different": "{attribute} und {other} müssen sich unterscheiden.",
            "digits": "{attribute} muss {digits} Stellen haben.",
            "digits_between": "{attribute} muss zwischen {min} und {max} Stellen haben.",
            "dimensions": "{attribute} hat ungültige Bildabmessungen.",
            "distinct": "{attribute} beinhaltet einen bereits vorhandenen Wert.",
            "email": "{attribute} muss eine gültige E-Mail-Adresse sein.",
            "exists": "Der gewählte Wert für {attribute} ist ungültig.",
            "file": "{attribute} muss eine Datei sein.",
            "filled": "{attribute} muss ausgefüllt sein.",
            "gt": {
                "numeric": "{attribute} muss mindestens {value} sein.",
                "file": "{attribute} muss mindestens {value} Kilobytes groß sein.",
                "string": "{attribute} muss mindestens {value} Zeichen lang sein.",
                "array": "{attribute} muss mindestens {value} Elemente haben."
            },
            "gte": {
                "numeric": "{attribute} muss größer oder gleich {value} sein.",
                "file": "{attribute} muss größer oder gleich {value} Kilobytes sein.",
                "string": "{attribute} muss größer oder gleich {value} Zeichen lang sein.",
                "array": "{attribute} muss größer oder gleich {value} Elemente haben."
            },
            "image": "{attribute} muss ein Bild sein.",
            "in": "Der gewählte Wert für {attribute} ist ungültig.",
            "in_array": "Der gewählte Wert für {attribute} kommt nicht in {other} vor.",
            "integer": "{attribute} muss eine ganze Zahl sein.",
            "ip": "{attribute} muss eine gültige IP-Adresse sein.",
            "ipv4": "{attribute} muss eine gültige IPv4-Adresse sein.",
            "ipv6": "{attribute} muss eine gültige IPv6-Adresse sein.",
            "json": "{attribute} muss ein gültiger JSON-String sein.",
            "lt": {
                "numeric": "{attribute} muss kleiner {value} sein.",
                "file": "{attribute} muss kleiner {value} Kilobytes groß sein.",
                "string": "{attribute} muss kleiner {value} Zeichen lang sein.",
                "array": "{attribute} muss kleiner {value} Elemente haben."
            },
            "lte": {
                "numeric": "{attribute} muss kleiner oder gleich {value} sein.",
                "file": "{attribute} muss kleiner oder gleich {value} Kilobytes sein.",
                "string": "{attribute} muss kleiner oder gleich {value} Zeichen lang sein.",
                "array": "{attribute} muss kleiner oder gleich {value} Elemente haben."
            },
            "max": {
                "numeric": "{attribute} darf maximal {max} sein.",
                "file": "{attribute} darf maximal {max} Kilobytes groß sein.",
                "string": "{attribute} darf maximal {max} Zeichen haben.",
                "array": "{attribute} darf nicht mehr als {max} Elemente haben."
            },
            "mimes": "{attribute} muss den Dateityp {values} haben.",
            "mimetypes": "{attribute} muss den Dateityp {values} haben.",
            "min": {
                "numeric": "{attribute} muss mindestens {min} sein.",
                "file": "{attribute} muss mindestens {min} Kilobytes groß sein.",
                "string": "{attribute} muss mindestens {min} Zeichen lang sein.",
                "array": "{attribute} muss mindestens {min} Elemente haben."
            },
            "not_in": "Der gewählte Wert für {attribute} ist ungültig.",
            "not_regex": "{attribute} hat ein ungültiges Format.",
            "numeric": "{attribute} muss eine Zahl sein.",
            "present": "{attribute} muss vorhanden sein.",
            "regex": "{attribute} Format ist ungültig.",
            "required": "{attribute} muss ausgefüllt sein.",
            "required_if": "{attribute} muss ausgefüllt sein, wenn {other} {value} ist.",
            "required_unless": "{attribute} muss ausgefüllt sein, wenn {other} nicht {values} ist.",
            "required_with": "{attribute} muss angegeben werden, wenn {values} ausgefüllt wurde.",
            "required_with_all": "{attribute} muss angegeben werden, wenn {values} ausgefüllt wurde.",
            "required_without": "{attribute} muss angegeben werden, wenn {values} nicht ausgefüllt wurde.",
            "required_without_all": "{attribute} muss angegeben werden, wenn keines der Felder {values} ausgefüllt wurde.",
            "same": "{attribute} und {other} müssen übereinstimmen.",
            "size": {
                "numeric": "{attribute} muss gleich {size} sein.",
                "file": "{attribute} muss {size} Kilobyte groß sein.",
                "string": "{attribute} muss {size} Zeichen lang sein.",
                "array": "{attribute} muss genau {size} Elemente haben."
            },
            "starts_with": "The {attribute} must start with one of the following: {values}",
            "string": "{attribute} muss ein String sein.",
            "timezone": "{attribute} muss eine gültige Zeitzone sein.",
            "unique": "{attribute} ist schon vergeben.",
            "uploaded": "{attribute} konnte nicht hochgeladen werden.",
            "url": "{attribute} muss eine URL sein.",
            "uuid": "{attribute} muss ein UUID sein.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": {
                "name": "Name",
                "username": "Benutzername",
                "email": "E-Mail-Adresse",
                "first_name": "Vorname",
                "last_name": "Nachname",
                "password": "Passwort",
                "password_confirmation": "Passwort-Bestätigung",
                "city": "Stadt",
                "country": "Land",
                "address": "Adresse",
                "phone": "Telefonnummer",
                "mobile": "Handynummer",
                "age": "Alter",
                "sex": "Geschlecht",
                "gender": "Geschlecht",
                "day": "Tag",
                "month": "Monat",
                "year": "Jahr",
                "hour": "Stunde",
                "minute": "Minute",
                "second": "Sekunde",
                "title": "Titel",
                "content": "Inhalt",
                "description": "Beschreibung",
                "excerpt": "Auszug",
                "date": "Datum",
                "time": "Uhrzeit",
                "available": "verfügbar",
                "size": "Größe"
            }
        }
    },
    "en": {
        "admin": {
            "cold": "Cold",
            "warm": "Warm",
            "warm_delivery": "Warm delivery",
            "delivery": "Delivery",
            "cold_delivery": "Cold delivery",
            "employees": "Employees",
            "employee_groups": "Employee groups",
            "groups": "Groups",
            "new_group": "New group",
            "title": "Title",
            "close": "Close",
            "description": "Description",
            "search": "Search",
            "action": "Action",
            "comment": "Comment",
            "submit": "Submit",
            "validate": "Validate",
            "added_success": "Added with success!",
            "edit": "Edit",
            "contact": "Contact",
            "deleted_success": "Deleted with success!",
            "delete_confirm": "Are you sure to delete? This action is irreversible!",
            "family_name": "Family name",
            "first_name": "First name",
            "email": "Email",
            "active": "Active",
            "group": "Group",
            "password": "Password",
            "employee": "Employee",
            "new_employee": "New employee",
            "no_permission": "You don't have the permission for this action!",
            "clients": "Clients",
            "company": "Company",
            "address": "Address",
            "complement": "Complement",
            "post_box": "Post box",
            "npa": "Postal code",
            "city": "City",
            "inactive": "Inactive",
            "contact_person": "Contact person",
            "client_structure": "Customer structure",
            "state": "State",
            "new_client": "New client",
            "client": "Client",
            "updated_success": "Updated with success!",
            "mobile": "Mobile",
            "phone": "Phone",
            "new_contact": "New contact",
            "structures": "Structures",
            "name": "Name",
            "structure": "Structure",
            "add": "Add",
            "company_complement": "Company complement"
        },
        "auth": {
            "failed": "These credentials do not match our records.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds."
        },
        "front": {
            "register": "Register",
            "please_confirm": "Please Confirm Your Email Address.",
            "please_check_email": "Please check your email box to activate your account",
            "home": "Home",
            "search": "search",
            "logout": "Logout",
            "category": "Category",
            "categories": "Categories",
            "close": "Close",
            "cancel": "Cancel",
            "contact": "Contact",
            "message": "Message",
            "contact_info": "Contact Info",
            "article": "Article",
            "articles": "Articles",
            "new_article": "New article",
            "title": "Title",
            "content": "Content",
            "confirm_delete_article": "Are you sure to delete this article? This action is irreversible! ",
            "article_published": "Your article has been published!",
            "article_updated": "Your article has been updated!",
            "article_deleted": "Your article has been deleted!",
            "owner_name": "Nom de Contact",
            "send_message": "Send a message",
            "from": "from",
            "subject": "Subject",
            "submit": "Submit",
            "all_fields_required": "All fields are required",
            "email": "Email",
            "address": "Address",
            "phone": "Phone number",
            "postcode": "Post code",
            "locality": "Locality",
            "image": "Image",
            "optional": "optional",
            "save": "Save Changes",
            "add": "Add",
            "edit": "Edit",
            "delete": "Delete",
            "confirm_delete": "Do you really want to delete this item? This action is irreversible! ",
            "description": "Description",
            "required_fields": "Requird Fields",
            "publish": "Publish",
            "published": "Published",
            "published_by": "Published by",
            "one_last_step": "One Last Step",
            "confirm_email_message": "We just need you to confirm your email address to prove that you're a human. ",
            "name": "Name",
            "more": "More",
            "confirmed": "Confirmed",
            "create_new": "Create New",
            "action": "Action",
            "welcome": "Welcome",
            "users": "Users",
            "create_success": "Successfully created.",
            "return": "Return",
            "create_channel": "Create Channel",
            "icon": "Icon",
            "number_registered_users": "Number of registered users",
            "publish_success": "Published with success!",
            "updated_success": "Updated with success!",
            "deleted_success": "Deleted with success!",
            "no_permission": "You do not have permission to perform this action.",
            "confirm": "Confirm",
            "text": "Text",
            "about": "About",
            "list": "List",
            "account": "Account",
            "my_objects": "My objects",
            "loading": "Loading",
            "balance": "Balance",
            "create": "Create",
            "serial_number": "Serial Number",
            "type": "Type",
            "original_country": "Original country",
            "ch_number": "CH number",
            "producer": "Producer",
            "model": "Model",
            "caliber": "Calibre",
            "smaller_than_60cm": "Smaller than 60 cm",
            "large_capacity_store": "Large capacity store",
            "serial_number_info": "Please use only characters without accents. Spaces prohibited. Authorized separators: . Point  - Hyphen  _Underscore",
            "yes": "yes",
            "no": "no",
            "objects": "Objects",
            "transfer": "transfer",
            "authorizations": "authorizations",
            "ownership": "Ownership",
            "approved": "Approved",
            "approval": "Approval",
            "recipient": "Receipient",
            "doctype": "Type of identity document",
            "docnumber": "Number of identity document",
            "family_name": "Family Name",
            "maiden_name": "Maiden Name",
            "first_name": "First Name",
            "birthday": "Birthday",
            "state": "State",
            "npa": "POST Code",
            "place": "Place",
            "information": "information",
            "create_conflict": "Creation conflict, please check the alerts below",
            "conflict_message": "An object of the same type and same serial number is already assigned to another holding address",
            "handle_conflict": "Handle this conflict",
            "copy": "copy",
            "logs": "logs",
            "translations": "Translations",
            "start": "start",
            "owner": "Owner"
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "passwords": {
            "password": "Passwords must be at least eight characters and match the confirmation.",
            "reset": "Your password has been reset!",
            "sent": "We have e-mailed your password reset link!",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that e-mail address."
        },
        "routes": {
            "home": "home"
        },
        "translation": {
            "warning_publish": "Warning, translations are not visible until they are exported back to the app/lang file, using",
            "command_or_publish_button": "command or publish button",
            "append_new_translations": "Append new translations",
            "replace_existing_translations": "Replace existing translations",
            "import_groups": "Import groups",
            "confirm_scan_folder": "Are you sure you want to scan you app folder? All found translation keys will be added to the database.",
            "find_translations": "Find translations in files",
            "confirm_publish_group": "Are you sure you want to publish the translations group",
            "will_orverwrite": "This will overwrite existing language files.",
            "publish_translations": "Publish translations",
            "back": "Back",
            "choose_group": "Choose a group to display the group translations. If no groups are visisble, make sure you have run the migrations and imported the translations.",
            "enter_new_group_name": "Enter a new group name and start edit translations in that group",
            "add_group": "Add group",
            "add_new_keys": "Add new keys to this group",
            "add_1_key_per_line": "Add 1 key per line, without the group prefix",
            "total": "Total",
            "changed": "changed",
            "key": "Key",
            "confirm_delete_key": "Are you sure you want to delete the translations for",
            "enter_translation": "Enter translation",
            "add_keys": "Add keys",
            "export_all": "Export all translations",
            "confirm_publish_all": "Are you sure you want to publish all translations group? This will overwrite existing language files.",
            "publish_all": "Publish all",
            "confirm_remove_locale": "Are you sure to remove this locale and all of data?",
            "current_locales": "Current supported locales",
            "enter_new_locale": "Enter new locale key",
            "add_new_locale": "Add new locale",
            "supported_locales": "Supported locales",
            "done_publishing_group": "Done publishing the translations for group",
            "done_publishing_all": "Done publishing the translations for all group!",
            "done_searching_translations": "Done searching for translations",
            "done_importing": "Done importing",
            "reload_page_refresh_groups": "Reload this page to refresh the groups",
            "processed": "processed",
            "found": "found",
            "items": "items"
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_equals": "The {attribute} must be a date equal to {date}.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "ends_with": "The {attribute} must end with one of the following: {values}",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} are present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "starts_with": "The {attribute} must start with one of the following: {values}",
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "uuid": "The {attribute} must be a valid UUID.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        }
    },
    "fr": {
        "A fresh verification link has been sent to your email address.": "Un nouveau lien de vérification a été envoyé à votre adresse email.",
        "All rights reserved.": "Tous droits réservés.",
        "Before proceeding, please check your email for a verification link.": "Avant de continuer, veuillez vérifier votre courrier électronique pour un lien de vérification.",
        "click here to request another": "cliquer ici pour faire une autre demande",
        "Confirm Password": "Confirmez le mot de passe",
        "E-Mail Address": "Adresse email",
        "Error": "Erreur",
        "Forbidden": "Interdit",
        "Forgot Your Password?": "Vous avez oublié votre mot de passe ?",
        "Go Home": "Aller à l'accueil",
        "Hello!": "Bonjour !",
        "hi": "salut",
        "If you did not create an account, no further action is required.": "Si vous n'avez pas créé de compte, aucune action supplémentaire n'est requise.",
        "If you did not receive the email": "Si vous n'avez pas reçu l'email",
        "If you did not request a password reset, no further action is required.": "Si vous n'avez pas demandé de réinitialisation de mot de passe, aucune autre action n'est requise.",
        "If you’re having trouble clicking the \"{actionText}\" button, copy and paste the URL below\ninto your web browser: [{actionURL}]({actionURL})": "Si vous avez des problèmes en cliquant sur le bouton \"{actionText}\", faites un copié/collé de l'url ci-dessous dans votre navigateur :\n [{actionURL}]({actionURL})",
        "Login": "Connexion",
        "Logout": "Déconnexion",
        "Name": "Nom",
        "Oh no": "Oh non",
        "Page Expired": "Page expirée",
        "Page Not Found": "Page non trouvée",
        "Password": "Mot de passe",
        "Please click the button below to verify your email address.": "Veuillez cliquer sur le bouton ci-dessous pour vérifier votre adresse email.",
        "Regards": "Cordialement",
        "Register": "S'inscrire",
        "Remember Me": "Se souvenir de moi",
        "Reset Password": "Réinitialisation du mot de passe",
        "Reset Password Notification": "Notification de réinitialisation du mot de passe",
        "Send Password Reset Link": "Envoyer le lien de réinitialisation du mot de passe",
        "Service Unavailable": "Service indisponible",
        "Sorry, the page you are looking for could not be found.": "Désolé, la page que vous recherchez est introuvable.",
        "Sorry, you are forbidden from accessing this page.": "Désolé, vous ne pouvez accéder à cette page.",
        "Sorry, you are making too many requests to our servers.": "Désolé, vous faites trop de requêtes vers nos serveurs.",
        "Sorry, you are not authorized to access this page.": "Désolé, vous n'êtes pas autorisé à accéder à cette page.",
        "Sorry, your session has expired. Please refresh and try again.": "Désolé, votre session a expiré. Veuillez actualiser la page et réessayer.",
        "Sorry, we are doing some maintenance. Please check back soon.": "Désolé, nous sommes en maintenance. Veuillez revenir plus tard.",
        "This password reset link will expire in {count} minutes.": "Ce lien de réinitialisation du mot de passe expirera dans {count} minutes.",
        "Toggle navigation": "Basculer la navigation",
        "Too Many Requests": "Trop de requêtes",
        "Unauthorized": "Non autorisé",
        "Verify Email Address": "Vérification de l'adresse email",
        "Verify Your Email Address": "Vérifiez votre adresse email",
        "You are receiving this email because we received a password reset request for your account.": "Vous recevez cet email car nous avons reçu une demande de réinitialisation de mot de passe pour votre compte.",
        "Whoops!": "Oups !",
        "Whoops, something went wrong on our servers.": "Oups, quelque chose s'est mal passé sur nos serveurs.",
        "Articles": "Articles",
        "Search": "Recherche",
        "Title": "Titre",
        "home": "accueil",
        "about": "à propos",
        "Action": "Action",
        "Modifed with success!": "Modifié avec succès!",
        "Added with success!": "Ajouté avec succès!",
        "admin": {
            "warm": "Chaude",
            "cold": "Froide",
            "relation_type": "Type de relation",
            "cold_delivery": "Liaison froide",
            "warm_delivery": "Liaison chaude",
            "delivery": "Livraison",
            "notice_admin": "Notice admin",
            "employee_groups": "Groupes d'employés",
            "employees": "Employés",
            "notice_client": "Notice client",
            "groups": "Groupes",
            "new_group": "Nouveau groupe",
            "notice": "Notice",
            "title": "Titre",
            "description": "Description",
            "search": "Recherche",
            "validate_medical": "Dossier médicale validé",
            "close": "Fermer",
            "action": "Action",
            "birthday": "Date de naissance",
            "comment": "Commentaire",
            "submit": "Soumettre",
            "validate": "Valider",
            "designation": "Désignation",
            "added_success": "Ajouté avec succès!",
            "edit": "Modifier",
            "principal_site": "Site de production principal",
            "phone": "Téléphone fixe",
            "contact": "Contact",
            "deleted_success": "Effacé avec succès!",
            "production_site": "Site de production",
            "delete_confirm": "Vous êtes sûre d'éffacer? Cette action est irréversible!",
            "site": "Site",
            "email": "Email",
            "family_name": "Nom",
            "first_name": "Prénom",
            "structures_number": "Structure client affilié",
            "client_service_phone": "Téléphone service client",
            "active": "Actif",
            "group": "Groupe",
            "name_public": "Désignation publique",
            "password": "Mot de passe",
            "employee": "Employé",
            "production": "Production",
            "new_employee": "Nouvel employé",
            "no_permission": "Vous n'avez pas la permission pour cette action!",
            "translations": "Traductions",
            "production_sites": "Sites de production",
            "clients": "Clients",
            "company": "Raison sociale",
            "settings": "Paramétrage",
            "address": "Adresse",
            "complement": "Complément",
            "added_value_chf": "Plus-value en CHF",
            "post_box": "Case postale",
            "npa": "NPA",
            "city": "Lieu",
            "consumer_affiliation": "Affiliation de consommateurs actifs",
            "price": "Prix",
            "inactive": "Inactif",
            "contact_person": "Personne de contact",
            "client_structure": "Structure client",
            "preference": "Préférence",
            "state": "Statut",
            "convenience": "Commodité",
            "new_client": "Nouveau client",
            "client": "Client",
            "danger": "Danger",
            "updated_success": "Modifié avec succès",
            "mobile": "Téléphone mobile",
            "preference_level": "Niveau de responsabilité",
            "level": "Niveau",
            "new_contact": "Nouveau contact",
            "preferences": "Préférences",
            "structures": "Structures",
            "name": "Nom",
            "consumers": "Consommateurs",
            "structure": "Structure",
            "add": "Ajouter",
            "company_complement": "Complément de raison social",
            "consumer": "Consommateur",
            "informations": "Informations",
            "documents": "Documents",
            "attachments": "Pièces jointes",
            "label": "Label",
            "employees_number": "Nombre des employés",
            "employees_list": "Liste des employés",
            "medical_document": "Dossier médicale",
            "yes": "oui",
            "no": "non",
            "set_modify_password": "Attribuer/modifier le mot de passe",
            "affiliate": "Affiliation",
            "confirm_password": "Vérification mot de passe",
            "save": "enregister",
            "assign_client": "Attribuer un client",
            "site_attribution": "Attribution de site",
            "attribution": "Attribution",
            "delivery_type": "Type de liaison",
            "replacement_site": "Site de remplacement",
            "delivery_address": "Adresse",
            "address_complement": "Complement d'adresse",
            "affiliated_sites": "Sites affiliés",
            "affiliated_structures": "Nombre de structures clients affiliés",
            "from": "du",
            "to": "au",
            "included": "inclus",
            "food": "Aliments",
            "base_menu": "Base menu",
            "plates": "Plats",
            "variations": "Variations",
            "nutrition": "Nutrition",
            "formats": "Formats",
            "type": "Type",
            "types": "Types",
            "definition": "Définition",
            "cycle": "Cycle",
            "available": "Disponible",
            "type_options": "Options de type",
            "planification_info": "Information de planification",
            "type_affiliation": "Affilication de type",
            "affiliated_production_sites": "Sites de production affiliés",
            "plate": "Plat",
            "type_link": "Lien de type",
            "variation": "Variation",
            "info_bulb": "Infobulle client",
            "color": "Couleur",
            "configuration": "Configuration",
            "format": "Format",
            "prestations_base": "Base de prestations",
            "frequence": "Fréquence",
            "display": "Affichage",
            "download_center": "Centre de téléchargement des documents",
            "per_unit": "par unité",
            "order": "Commande",
            "plus_value": "Plus-value",
            "wholesale": "En bloc",
            "retail": "Détail",
            "cancel": "Annuler",
            "if_menu_week_valid": "Si le menu hebdomadaire est validé pour une journée",
            "order_limits": "Limites de commande",
            "mask_menu": "Masquer le menu pour la journée",
            "allow_order": "Autoriser la commande du menu le même jour",
            "prefer_level_1": "COMMODITÉ 1",
            "prefer_level_2": "COMMODITÉ 2",
            "prefer_level_3": "COMMODITÉ 3",
            "note": "Remarque",
            "divers": "Divers",
            "affiliated_to": "affiliés à",
            "dietary_preferences": "Préférences alimentaire",
            "affiliation_of_active_consumers": "Affiliation de consommateurs actifs",
            "bound": "lié",
            "subsistence_plan": "Plan subsistance",
            "basic_planning": "planification de base",
            "planning": "Planification",
            "base": "Base",
            "week": "Semaine",
            "preparation": "Régénération",
            "dish": "Base menu",
            "dishes": "Base menu",
            "correct": "corriger",
            "variation_limits": "Limites de variations",
            "quantity": "Quantité",
            "unit": "Unité",
            "close_date": "Date de fermeture",
            "states": "Statuts",
            "festive_menu": "menu festif",
            "order_states": "Statuts de commande",
            "summary_of_activities": "Récapitulatif des activités",
            "production_state": "Statut production",
            "orders": "Commandes",
            "festive": "festif",
            "desired_weekly_menu_on": "Menu hebdomadaire souhaité le",
            "notice_structure": "Notice structure client",
            "notice_site": "Notice site de production",
            "stewardship": "Économat",
            "information_B": "Information_B",
            "situation": "Situation",
            "economat": "Économat",
            "sub_categories": "Sous catégories",
            "category": "Catégorie",
            "categories": "Catégories",
            "sub_category": "Sous catégorie",
            "product": "Produit",
            "products": "Produits",
            "attribute": "Attribut",
            "attributes": "Attributs",
            "allow": "Autoriser",
            "not_allow": "Non autoriser",
            "piece": "Pièce",
            "updated": "a mis à jour",
            "at": "à",
            "locked": "verrouillé",
            "open": "ouvert",
            "admin": "Admin",
            "day": "Jour",
            "image": "Image",
            "upload": "Télécharger",
            "function": "Fonction",
            "value": "Valeur",
            "assign_clients": "Attribuer clients",
            "to_client": "au client",
            "to_structure": "à la structure",
            "billing": "Facturation",
            "responsable_bill": "Personne responsable de la facturation",
            "name_complement": "complément de nom",
            "telephone": "Téléphone",
            "all_contacts": "Tous les contacts"
        },
        "auth": {
            "failed": "Ces identifiants ne correspondent pas à nos enregistrements",
            "throttle": "Tentatives de connexion trop nombreuses. Veuillez essayer de nouveau dans {seconds} secondes."
        },
        "front": {
            "register": "Inscription",
            "please_confirm": "Veuillez confirmer votre adresse e-mail.",
            "please_check_email": "Veuillez vérifier votre boîte email pour activer votre compte.",
            "home": "Acceuil",
            "search": "recherche",
            "logout": "Déconnexion",
            "category": "Catégorie",
            "categories": "Catégories",
            "close": "Fermer",
            "cancel": "Annuler",
            "contact": "Contact",
            "message": "Message",
            "contact_info": "Informations de contact",
            "article": "Article",
            "articles": "Articles",
            "new_article": "Nouvel article",
            "title": "Titre",
            "content": "Contenu",
            "confirm_delete_article": "Vous êtes sûre d'effacer cet article? cette action est irreversible!",
            "article_published": "Votre article a été publié!",
            "article_updated": "Votre article a été mis à jour!",
            "article_deleted": "Votre article a été supprimé!",
            "owner_name": "Nom de Contact",
            "send_message": "Envoyer un message",
            "from": "de",
            "subject": "Sujet",
            "submit": "Valider",
            "all_fields_required": "Tous les champs sont requis",
            "email": "Adresse email",
            "address": "Adresse",
            "phone": "Numéro de téléphone",
            "postcode": "Code postal",
            "locality": "Localité",
            "image": "image",
            "optional": "optionnelle",
            "save": "Sauvegarder",
            "add": "Ajouter",
            "edit": "Modifier",
            "delete": "Supprimer",
            "confirm_delete": "Voulez-vous vraiment supprimer cet objet? Cette action est irréversible! ",
            "description": "Description",
            "required_fields": "Champs Obligatoires",
            "publish": "Publier",
            "published": "publié",
            "published_by": "publié par",
            "confirm_email_message": "Vous devez valider la création du compte en cliquant sur le lien ci-dessous.",
            "name": "Nom",
            "more": "Autres",
            "confirmed": "Confirmé",
            "create_new": "Créer un nouveau",
            "action": "Action",
            "welcome": "Bienvenue",
            "users": "Utilisateurs",
            "create_successs": "Créé avec succès",
            "return": "Retourner",
            "icon": "icône",
            "number_registered_users": "Nombre d'utilisateurs enregistrés",
            "publish_success": "Publié avec succès!",
            "updated_success": "Mis à jour avec succès!",
            "deleted_success": "Supprimé avec succès!",
            "logs": "Historique",
            "dashboard": "dashboard",
            "no_permission": "Vous n'avez pas la permission d'effectuer cette action",
            "confirm": "Confirmer",
            "text": "Texte",
            "about": "À propos",
            "list": "Liste",
            "account": "Identifiant",
            "my_objects": "Mes objets",
            "loading": "Chargement",
            "balance": "Balance",
            "create": "Créer",
            "serial_number": "Numéro de serie",
            "type": "Type",
            "original_country": "Pays d'origine",
            "ch_number": "Numéro CH",
            "producer": "Fabricant",
            "model": "Modèle",
            "caliber": "Calibre",
            "smaller_than_60cm": "Moins de 60 cm",
            "large_capacity_store": "Magasin grande capacité",
            "serial_number_info": "Veuillez utiliser uniquement des caractères sans accents. Espaces interdits. Séparateurs autoriés: . Point  - Trait d'union _ Underscore",
            "yes": "oui",
            "no": "non",
            "objects": "Objets",
            "transfer": "transférer",
            "authorizations": "autorisations",
            "ownership": "Détention",
            "approved": "Approuvé",
            "approval": "Approbation",
            "recipient": "Destinaire",
            "doctype": "Type de document d'identité",
            "docnumber": "Numéro du document d'identité",
            "family_name": "Nom de famile",
            "maiden_name": "Nom de jeune fille",
            "first_name": "Prénom",
            "birthday": "Date de naissance",
            "state": "Canton",
            "npa": "NPA",
            "place": "Lieu",
            "information": "informations",
            "create_conflict": "Conflit de création, veuillez vérifier les alerts ci-dessous",
            "conflict_message": "Un object du même type et même numéro de série est jéjà attribué à une autre adresse de détention",
            "handle_conflict": "Gérer ce conflict",
            "copy": "copier",
            "translations": "Traductions",
            "owner": "Propriétaire",
            "consumers": "Consommateurs",
            "consumer": "Consommateur"
        },
        "pagination": {
            "previous": "&laquo; Précédent",
            "next": "Suivant &raquo;"
        },
        "passwords": {
            "password": "Les mots de passe doivent contenir au moins six caractères et être identiques.",
            "reset": "Votre mot de passe a été réinitialisé !",
            "sent": "Nous vous avons envoyé par email le lien de réinitialisation du mot de passe !",
            "token": "Ce jeton de réinitialisation du mot de passe n'est pas valide.",
            "user": "Aucun utilisateur n'a été trouvé avec cette adresse email."
        },
        "routes": {
            "home": "accueil"
        },
        "translation": {
            "warning_publish": "Attention, les traductions ne sont visibles qu’après leur exportation dans le fichier app / lang, à l’aide de",
            "command_or_publish_button": "commande ou bouton de publication",
            "append_new_translations": "Ajouter de nouvelles traductions",
            "replace_existing_translations": "Remplacer les traductions existantes",
            "import_groups": "Importer groupes",
            "confirm_scan_folder": "Êtes-vous sûr de vouloir analyser votre dossier d'applications? Toutes les clés de traduction trouvées seront ajoutées à la base de données.",
            "find_translations": "Trouver des traductions dans des fichiers",
            "confirm_publish_group": "Êtes-vous sûr de vouloir publier le groupe de traductions",
            "will_orverwrite": "Cela écrasera les fichiers de langue existants.",
            "publish_translations": "Publier les traductions",
            "back": "Retour",
            "choose_group": "Choisissez un groupe pour afficher les traductions du groupe. Si aucun groupe n'est visible, assurez-vous d'avoir effectué les migrations et importé les traductions.",
            "enter_new_group_name": "Entrez un nouveau nom de groupe et commencez à modifier les traductions de ce groupe",
            "add_group": "Ajouter un groupe",
            "add_new_keys": "Ajouter de nouvelles clés à ce groupe",
            "add_1_key_per_line": "Ajouter 1 clé par ligne, sans le préfixe du groupe",
            "total": "Totale",
            "changed": "modifié",
            "key": "Clé",
            "confirm_delete_key": "Etes-vous sûr de vouloir supprimer les traductions pour",
            "enter_translation": "Entrez la traduction",
            "add_keys": "Ajouter des clés",
            "export_all": "Exporter toutes les traductions",
            "confirm_publish_all": "Êtes-vous sûr de vouloir publier tous les groupes de traductions? Cela écrasera les fichiers de langue existants.",
            "publish_all": "Publier tout",
            "confirm_remove_locale": "Êtes-vous sûr de vouloir supprimer ces paramètres régionaux et toutes les données?",
            "current_locales": "Langues actuellement supportées",
            "enter_new_locale": "Entrez la nouvelle clé locale",
            "add_new_locale": "Ajouter une nouvelle locale",
            "supported_locales": "Locaux pris en charge",
            "done_publishing_group": "Terminé la publication des traductions pour le groupe",
            "done_publishing_all": "Terminé la publication des traductions pour tout le groupe!",
            "done_searching_translations": "Terminé la recherche de traductions",
            "done_importing": "Importation terminée",
            "reload_page_refresh_groups": "Recharger cette page pour actualiser les groupes",
            "processed": "traité",
            "found": "a trouvé",
            "items": "articles"
        },
        "validation": {
            "accepted": "Le champ {attribute} doit être accepté.",
            "active_url": "Le champ {attribute} n'est pas une URL valide.",
            "after": "Le champ {attribute} doit être une date postérieure au {date}.",
            "after_or_equal": "Le champ {attribute} doit être une date postérieure ou égale au {date}.",
            "alpha": "Le champ {attribute} doit contenir uniquement des lettres.",
            "alpha_dash": "Le champ {attribute} doit contenir uniquement des lettres, des chiffres et des tirets.",
            "alpha_num": "Le champ {attribute} doit contenir uniquement des chiffres et des lettres.",
            "array": "Le champ {attribute} doit être un tableau.",
            "before": "Le champ {attribute} doit être une date antérieure au {date}.",
            "before_or_equal": "Le champ {attribute} doit être une date antérieure ou égale au {date}.",
            "between": {
                "numeric": "La valeur de {attribute} doit être comprise entre {min} et {max}.",
                "file": "La taille du fichier de {attribute} doit être comprise entre {min} et {max} kilo-octets.",
                "string": "Le texte {attribute} doit contenir entre {min} et {max} caractères.",
                "array": "Le tableau {attribute} doit contenir entre {min} et {max} éléments."
            },
            "boolean": "Le champ {attribute} doit être vrai ou faux.",
            "confirmed": "Le champ de confirmation {attribute} ne correspond pas.",
            "date": "Le champ {attribute} n'est pas une date valide.",
            "date_equals": "Le champ {attribute} doit être une date égale à {date}.",
            "date_format": "Le champ {attribute} ne correspond pas au format {format}.",
            "different": "Les champs {attribute} et {other} doivent être différents.",
            "digits": "Le champ {attribute} doit contenir {digits} chiffres.",
            "digits_between": "Le champ {attribute} doit contenir entre {min} et {max} chiffres.",
            "dimensions": "La taille de l'image {attribute} n'est pas conforme.",
            "distinct": "Le champ {attribute} a une valeur en double.",
            "email": "Le champ {attribute} doit être une adresse email valide.",
            "exists": "Le champ {attribute} sélectionné est invalide.",
            "file": "Le champ {attribute} doit être un fichier.",
            "filled": "Le champ {attribute} doit avoir une valeur.",
            "gt": {
                "numeric": "La valeur de {attribute} doit être supérieure à {value}.",
                "file": "La taille du fichier de {attribute} doit être supérieure à {value} kilo-octets.",
                "string": "Le texte {attribute} doit contenir plus de {value} caractères.",
                "array": "Le tableau {attribute} doit contenir plus de {value} éléments."
            },
            "gte": {
                "numeric": "La valeur de {attribute} doit être supérieure ou égale à {value}.",
                "file": "La taille du fichier de {attribute} doit être supérieure ou égale à {value} kilo-octets.",
                "string": "Le texte {attribute} doit contenir au moins {value} caractères.",
                "array": "Le tableau {attribute} doit contenir au moins {value} éléments."
            },
            "image": "Le champ {attribute} doit être une image.",
            "in": "Le champ {attribute} est invalide.",
            "in_array": "Le champ {attribute} n'existe pas dans {other}.",
            "integer": "Le champ {attribute} doit être un entier.",
            "ip": "Le champ {attribute} doit être une adresse IP valide.",
            "ipv4": "Le champ {attribute} doit être une adresse IPv4 valide.",
            "ipv6": "Le champ {attribute} doit être une adresse IPv6 valide.",
            "json": "Le champ {attribute} doit être un document JSON valide.",
            "lt": {
                "numeric": "La valeur de {attribute} doit être inférieure à {value}.",
                "file": "La taille du fichier de {attribute} doit être inférieure à {value} kilo-octets.",
                "string": "Le texte {attribute} doit contenir moins de {value} caractères.",
                "array": "Le tableau {attribute} doit contenir moins de {value} éléments."
            },
            "lte": {
                "numeric": "La valeur de {attribute} doit être inférieure ou égale à {value}.",
                "file": "La taille du fichier de {attribute} doit être inférieure ou égale à {value} kilo-octets.",
                "string": "Le texte {attribute} doit contenir au plus {value} caractères.",
                "array": "Le tableau {attribute} doit contenir au plus {value} éléments."
            },
            "max": {
                "numeric": "La valeur de {attribute} ne peut être supérieure à {max}.",
                "file": "La taille du fichier de {attribute} ne peut pas dépasser {max} kilo-octets.",
                "string": "Le texte de {attribute} ne peut contenir plus de {max} caractères.",
                "array": "Le tableau {attribute} ne peut contenir plus de {max} éléments."
            },
            "mimes": "Le champ {attribute} doit être un fichier de type : {values}.",
            "mimetypes": "Le champ {attribute} doit être un fichier de type : {values}.",
            "min": {
                "numeric": "La valeur de {attribute} doit être supérieure ou égale à {min}.",
                "file": "La taille du fichier de {attribute} doit être supérieure à {min} kilo-octets.",
                "string": "Le texte {attribute} doit contenir au moins {min} caractères.",
                "array": "Le tableau {attribute} doit contenir au moins {min} éléments."
            },
            "not_in": "Le champ {attribute} sélectionné n'est pas valide.",
            "not_regex": "Le format du champ {attribute} n'est pas valide.",
            "numeric": "Le champ {attribute} doit contenir un nombre.",
            "present": "Le champ {attribute} doit être présent.",
            "regex": "Le format du champ {attribute} est invalide.",
            "required": "Le champ {attribute} est obligatoire.",
            "required_if": "Le champ {attribute} est obligatoire quand la valeur de {other} est {value}.",
            "required_unless": "Le champ {attribute} est obligatoire sauf si {other} est {values}.",
            "required_with": "Le champ {attribute} est obligatoire quand {values} est présent.",
            "required_with_all": "Le champ {attribute} est obligatoire quand {values} sont présents.",
            "required_without": "Le champ {attribute} est obligatoire quand {values} n'est pas présent.",
            "required_without_all": "Le champ {attribute} est requis quand aucun de {values} n'est présent.",
            "same": "Les champs {attribute} et {other} doivent être identiques.",
            "size": {
                "numeric": "La valeur de {attribute} doit être {size}.",
                "file": "La taille du fichier de {attribute} doit être de {size} kilo-octets.",
                "string": "Le texte de {attribute} doit contenir {size} caractères.",
                "array": "Le tableau {attribute} doit contenir {size} éléments."
            },
            "starts_with": "Le champ {attribute} doit commencer avec une des valeurs suivantes : {values}",
            "string": "Le champ {attribute} doit être une chaîne de caractères.",
            "timezone": "Le champ {attribute} doit être un fuseau horaire valide.",
            "unique": "La valeur du champ {attribute} est déjà utilisée.",
            "uploaded": "Le fichier du champ {attribute} n'a pu être téléversé.",
            "url": "Le format de l'URL de {attribute} n'est pas valide.",
            "uuid": "Le champ {attribute} doit être un UUID valide",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": {
                "name": "nom",
                "username": "nom d'utilisateur",
                "email": "adresse email",
                "first_name": "prénom",
                "last_name": "nom",
                "password": "mot de passe",
                "password_confirmation": "confirmation du mot de passe",
                "city": "ville",
                "country": "pays",
                "address": "adresse",
                "phone": "téléphone",
                "mobile": "portable",
                "age": "âge",
                "sex": "sexe",
                "gender": "genre",
                "day": "jour",
                "month": "mois",
                "year": "année",
                "hour": "heure",
                "minute": "minute",
                "second": "seconde",
                "title": "titre",
                "content": "contenu",
                "description": "description",
                "excerpt": "extrait",
                "date": "date",
                "time": "heure",
                "available": "disponible",
                "size": "taille"
            }
        }
    }
}
